export enum ClientAccountInvoiceType {
  AccountingDepartment = "AccountingDepartment",
  Local = "Local",
  Central = "Central",
  None = "None",
}
